import { ElementRef, Injectable, NgZone } from '@angular/core';
// import { MatPaginatorIntl } from '@angular/material/paginator';
import { Router } from '@angular/router';
// import { TranslateService } from '@ngx-translate/core';
// import 'bootstrap-notify';
// declare var $: any;
// import * as $ from 'jquery';
import { Observable, of } from 'rxjs';
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { CustomSnackBar } from '../components/custom-snack-bar/custom-snack-bar';
import { Md5 } from 'ts-md5/dist/md5';
// import { SORD_DIRECTION } from '../models/sort';
import { NzMessageService } from 'ng-zorro-antd/message';
import { INzMessageType } from '@ascschool/interface/setting';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(
    private router: Router,
    // private matCus: MatPaginatorIntl,
    // private _snackBar: MatSnackBar,
    private zone: NgZone,
    private msg: NzMessageService,
    private notify: NzNotificationService,
  ) {}

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
  }

  padIntegerLeftWithZeros(rawInteger: number, numberOfDigits: number): string {
    let paddedInteger: string = rawInteger + '';
    while (paddedInteger.length < numberOfDigits) {
      paddedInteger = '0' + paddedInteger;
    }
    return paddedInteger;
  }

  rgb2hex(rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return rgb && rgb.length === 4
      ? '#' +
          ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
          ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2)
      : '';
  }

  md5Encode(str: number | string): string {
    let s: string = str ? '' + str : '';
    const md5 = new Md5();
    let result: any = md5.appendStr(s).end();
    if (result instanceof Int32Array) {
      result = result.join('');
    }
    return result.toUpperCase();
  }

  doNothing(): void {}

  getColumnValue(obj: any, colIndex: number, columnsNameVi: any[]): any {
    return obj[columnsNameVi[colIndex]];
  }

  isAValidDate(_date: any): boolean {
    _date = _date.toString();
    const _regExp = new RegExp(
      '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$'
    );
    return _regExp.test(_date);
  }

  getColumnValueWithDateTimeAble(obj: any, colIndex: number, columnsNameVi: any[]): any {
    if (this.isAValidDate(obj[columnsNameVi[colIndex]])) {
      return { value: obj[columnsNameVi[colIndex]], isDateType: true };
    }
    return { value: obj[columnsNameVi[colIndex]], isDateType: false };
  }

  stringDate(date: any, slash = false, noYear = false) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return slash
      ? noYear
        ? [day, month].join('/')
        : [day, month, year].join('/')
      : [year, month, day].join('-');
  }
  weekNumber(inputDate: Date): number {
    return inputDate.getDay();
  }

  yearsList(value: any, type: number | null = 1): Observable<any[]> {
    let list: any[] = [];

    for (let i = 1975; i <= 2100; i++) {
      list.push({
        value: i,
        title: '' + i
      });
    }

    if (type == 1) {
      return of(
        list.filter(
          (month: any) =>
            value == '' ||
            value == undefined ||
            month.title.toLowerCase().indexOf(value.toString()) != -1
        )
      );
    } else {
      return of(
        list.filter(
          (month: any) =>
            value == '' ||
            value == undefined ||
            month.value.toString().toLowerCase() == value.toString()
        )
      );
    }
  }

  //notification

  showNotification(type: INzMessageType, message: string, duration: number = 2000) {
    switch (type) {
      case INzMessageType.Success: {
        this.zone.run(() => {
          this.msg.success(message, {
            nzDuration: duration
          });
        });
        break;
      }
      case INzMessageType.Error: {
        this.zone.run(() => {
          this.msg.error(message, {
            nzDuration: duration
          });
        });
        break;
      }
      case INzMessageType.Warning: {
        this.zone.run(() => {
          this.msg.warning(message, {
            nzDuration: duration
          });
        });
        break;
      }
      default: {
        this.zone.run(() => {
          this.msg.success(message, {
            nzDuration: duration
          });
        });
        break;
      }
    }
  }
  FormatString(str: string, ...val: string[]) {
    for (let index = 0; index < val.length; index++) {
      str = str.replace(`{${index}}`, val[index]);
    }
    return str;
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  objectToString(object) {
    if (typeof object == 'object') return '';
    return object;
  }
  // md5Encode(str: number | string): string {
  //   let s: string = (str) ? ('' + str) : '';
  //   const md5 = new Md5();
  //   let result: any = md5.appendStr(s).end();
  //   if (result instanceof Int32Array) {
  //     result = result.join('');
  //   }
  //   return result.toUpperCase();
  // }
  createCopy(objectToCopy: any): any {
    return JSON.parse(JSON.stringify(objectToCopy));
  }
  formatThousandNumber(n: number) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  thousandFormatToNumber(n: string) {
    return parseInt(n.replace(/,/g, ''));
  }
  parseResponse(response: string) {
    return JSON.parse('{"' + response.replace(/;/g, '", "').replace(/=/g, '": "') + '"}');
  }
  chooseAvatar() {
    document.getElementById('fileImg').click();
  }
  chooseFile() {
    document.getElementById('file-selector').click();
  }
  decentralizedScreen(screenRoute: string) {
    let decentralization = JSON.parse(localStorage.getItem('decentralizedMenu')).find(
      (x: any) => x.routerMapping == screenRoute
    );
    if (!decentralization || !decentralization.allowRead) {
      this.router.navigate(['/unauthorized']);
    }
    return decentralization;
  }

  // updateMatTableLabel() {
  //   this.matCus.itemsPerPageLabel = 'Số mục trên trang';
  //   this.matCus.getRangeLabel = (page: number, pageSize: number, length: number): string => {
  //     if (length === 0 || pageSize === 0) {
  //       return 'Không có mục nào';
  //     }
  //     length = Math.max(length, 0);
  //     const startIndex = page * pageSize;
  //     const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
  //     return `${startIndex + 1} - ${endIndex} trên ${length}`;
  //   }
  // }

  notifyResponse(resp: { statusCode: number; message: string }) {
    this.showNotification(
      resp.statusCode === 0 ? INzMessageType.Success : INzMessageType.Error,
      resp.message
    );
  }

  bindOrUnBindTheId(theObject: any, fieldName: string, value: any) {
    if (value != null && typeof value != 'string') theObject[fieldName] = value.id;
    else delete theObject[fieldName];
  }
  //Thông báo validate
  showNotifyInvalidControls(formGroup: FormGroup, labelElement) {
    let countTime = 2500;
    this.notify.remove();
    const controls = formGroup.controls;
    for (const name in controls) {
      //Kiểm tra controls Array
      if(formGroup.get(name)['controls']){
        let arrControls = formGroup.get(name)['controls'];
        for (const controlArr of arrControls) {
          for(const nameA in controlArr.controls){
            if(controlArr.controls[nameA].invalid){
              controlArr.controls[nameA].markAsDirty();
              controlArr.controls[nameA].updateValueAndValidity();
            }
          }
        }
      }else{
        if (controls[name].invalid) {
          for(const element of labelElement.toArray()){
            if(element.nzFor === name){
              this.notify.warning(
                '',
                'Vui lòng nhập: '+ '<span class="notify-validate">"'+element.cdr._cdRefInjectingView[0].innerText+'"</span>',
                {
                  nzDuration: countTime,
                  nzStyle: {
                    border: '1px solid red' 
                  },
                },                
              );
              countTime+= 300;
            }
          }
          formGroup.controls[name].markAsDirty();
          formGroup.controls[name].updateValueAndValidity();
        }
      }
    }
  }
  notifyValidateNgModel(valueCheck, labelElement){
    let countTime = 2500;
    let count = 0;
    this.notify.remove();
    for(const element of labelElement.toArray()){
      if(valueCheck[element.nzFor] === null || valueCheck[element.nzFor] === '' || valueCheck[element.nzFor] === undefined){
        count++;
        this.notify.warning(
          '',
          'Vui lòng nhập: '+ '<span class="notify-validate">"'+element.cdr._cdRefInjectingView[0].innerText+'"</span>',
          {
            nzDuration: countTime,
            nzStyle: {
              border: '1px solid red' 
            },
          },                
        );
        countTime+= 300;
      }
    }
    if(count === 0){
      return true;
    }
  }
  notifyValidateSurvey(valueCheck, labelElement){
    let countTime = 2500;
    this.notify.remove();
    for(const element of labelElement.toArray()){
      if(valueCheck.includes(element.nzFor)){
        this.notify.warning(
          '',
          'Vui lòng nhập: '+ '<span class="notify-validate">"'+element.cdr._cdRefInjectingView[0].innerText+'"</span>',
          {
            nzDuration: countTime,
            nzStyle: {
              border: '1px solid red' 
            },
          },                
        );
        countTime+= 300;
      }
    }
  }
  findInvalidControlsbyForm(formGroup: FormGroup, formElement: ElementRef) {
    let countTime = 2500;
    this.notify.remove();
    const controls = formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        for(const element of formElement.nativeElement.elements){
          if(element.attributes.formcontrolname.value === name){
            this.notify.warning(
              '',
              'Vui lòng '+ '<span class="notify-validate">"'+element.attributes.placeholder.value+'"</span>' ,
              { 
                nzDuration: countTime,
                nzStyle: {
                  border: '1px solid red' 
                },
              }
            );
          }
          countTime+= 300;
        }
      }
      formGroup.controls[name].markAsDirty();
      formGroup.controls[name].updateValueAndValidity();
    }
  }  
}
